import React, { Component, PropTypes } from 'react';
import { Styles } from 'material-ui';

const { Spacing } = Styles;

const boxSizing = 'border-box';
const WebkitBoxSizing = 'border-box';
const MozBoxSizing = 'border-box';

const styles = {
  container: {
    boxSizing,
    WebkitBoxSizing,
    MozBoxSizing
  },
  media: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    boxSizing,
    WebkitBoxSizing,
    MozBoxSizing
  },
  body: {
    boxSizing,
    WebkitBoxSizing,
    MozBoxSizing
  },
  mediaObjectContainer: {
    height: 0,
    paddingBottom: `${Math.floor(9 * 100000 / 16) / 1000}%`,
    textAlign: 'center',
    boxSizing,
    WebkitBoxSizing,
    MozBoxSizing,
    position: 'relative'
  },
  mediaObject: {
    height: 350,
    width: '100%',
    // maxHheight: '100%',
    // maxWidth: '100%',
    // height: 'auto',
    verticalAlign: 'middle'
  },
  mediaObjectPhone: {
    maxHeight: '100%'
  },
  objectWrapper: {
    // alignItems: 'center',
    // justifyContent: 'center',
    position: 'absolute',
    overflow: 'hidden',
    left: 0,
    right: 0,
    bottom: 0,
    top: 0
  },
  caption: {
    minHeight: Spacing.desktopGutterMore
  }
};

const css = oxygenCss({
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  }
});

class MediaContainer extends Component {
  static displayName = 'MediaContainer';

  static propTypes = {
    controls: PropTypes.node,
    mediaObject: PropTypes.node,
    children: PropTypes.node,
    caption: PropTypes.node
  };

  render() {
    const { children, controls, caption } = this.props;
    const mediaObject = React.cloneElement(this.props.mediaObject, {
      style: styles.mediaObject
    });
    const zoom = children;

    return (
      <div style={styles.container}>
        <div style={styles.media}>
          <div>
            <div style={styles.mediaObjectContainer}>
              <div className={css.root} style={styles.objectWrapper}>
                {mediaObject}
                {zoom}
              </div>
            </div>
          </div>
          <div style={styles.body}>
            <figcaption style={styles.caption}>{caption}</figcaption>
            <div>{controls}</div>
          </div>
        </div>
      </div>
    );
  }
}

export default MediaContainer;



// WEBPACK FOOTER //
// ./src/js/components/MediaContainer.js